var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getLoader)?_c('article',{staticClass:"loader"},[_c('section',{staticClass:"loader_container"},[_vm._m(0),_c('img',{attrs:{"src":_vm.logo,"alt":""}})])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('span',{staticClass:"spinner"})])
}]

export { render, staticRenderFns }